import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Ensure skeleton CSS is imported

// No longer a modal, so no isOpen prop needed at this level.
// This component will be conditionally rendered by MainLayout.
export const ProfileCompletionCTA: React.FC = () => {
    return (
        <div className="relative w-full flex flex-col flex-1 min-h-0"> {/* Added flex flex-col flex-1 min-h-0 */}
            {/* Skeleton Background - Ensure it can expand */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 flex-1"> {/* Added flex-1 */}
                {/* Main content area skeletons */}
                <div className="lg:col-span-2 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Skeleton Card 1 */}
                        <div className="bg-white p-6 rounded-2xl shadow-custom">
                            <h2 className="text-xl font-semibold text-gray-900 mb-4">
                                <Skeleton width={200} />
                            </h2>
                            <p className="text-gray-600 whitespace-pre-wrap mb-4">
                                <Skeleton count={3} />
                            </p>
                            <Skeleton height={30} width={100} />
                        </div>
                        {/* Skeleton Card 2 */}
                        <div className="bg-white p-6 rounded-2xl shadow-custom">
                            <h2 className="text-xl font-semibold text-gray-900 mb-3">
                                <Skeleton width={150} />
                            </h2>
                            <div className="bg-gray-50 rounded-lg p-4">
                                <Skeleton height={60} />
                            </div>
                        </div>
                    </div>
                    {/* Skeleton Card 3 (full width in main area) */}
                    <div className="bg-white p-6 rounded-2xl shadow-custom">
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">
                            <Skeleton width={120} />
                        </h2>
                        <div className="bg-gray-50 rounded-lg p-4">
                            <Skeleton height={50} />
                        </div>
                    </div>
                </div>

                {/* Sidebar area skeleton */}
                <div className="space-y-6">
                    <div className="bg-white p-6 rounded-2xl shadow-custom">
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">
                            <Skeleton width={140} />
                        </h2>
                        <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                            <Skeleton height={40} />
                            <Skeleton height={40} />
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Overlay Content */}
            {/* Adjusted background for better skeleton visibility, ensure it covers the skeleton area */}
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-30 backdrop-blur-sm p-6 rounded-2xl">
                <div className="bg-white p-8 rounded-xl shadow-2xl text-center max-w-lg">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3">Complete Your Profile</h3>
                    <p className="text-gray-700 mb-6">
                        Unlock the full potential of holito by completing your profile. Get listed in the public network,
                        join communities, participate in competitions, and showcase your projects to the world.
                    </p>
                    <Link to="/register/onboarding">
                        <Button variant="filled" color="primary" size="large" className="whitespace-nowrap">
                            Complete Profile
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}; 